export default {
  props: {
    align: {
      type: [String, Object],
      default: null
    },
    grow: {
      type: [Boolean, Object],
      default: null
    },
    shrink: {
      type: [Boolean, Object],
      default: null
    }
  },
  vessel: {
    default: {
      $align: 'flexSelf',
      $grow: 'flexGrow',
      $shrink: 'flexShrink'
    }
  }
}
